import { ApplicationRef, ComponentFactory, ComponentRef, Injector } from '@angular/core';

export class DynamicComponentFactory<T> {
  private embeddedComponents: Array<ComponentRef<T>> = [];

  constructor(
    private appRef: ApplicationRef,
    private factory: ComponentFactory<T>,
    private injector: Injector
  ) {}

  createDynamicComponents(hostElement: Element): Array<ComponentRef<T>> {
    const dynamicHtmlElements = Array.prototype.slice.call(
      hostElement.querySelectorAll(this.factory.selector)
    ) as Element[];
    const componentRefs = dynamicHtmlElements.map((element) => this.createComponentRef(element));
    this.embeddedComponents.push(...componentRefs);
    componentRefs.forEach((componentRef) => this.appRef.attachView(componentRef.hostView));
    return componentRefs;
  }

  private createComponentRef(el: Element): ComponentRef<T> {
    const projectableNodes = [Array.prototype.slice.call(el.childNodes)];
    const componentRef = this.factory.create(this.injector, projectableNodes, el);
    const component = componentRef.instance;

    this.setComponentAttrs(component, el);

    return componentRef;
  }

  private setComponentAttrs(comp: T, el: Element): void {
    const anyComp = comp as Record<string, unknown>;
    for (const key in anyComp) {
      if (Object.prototype.hasOwnProperty.call(anyComp, key) && el.hasAttribute(key)) {
        anyComp[key] = el.getAttribute(key);
      }
    }
  }

  destroy(): void {
    this.embeddedComponents.forEach((componentRef) => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });
  }
}
